import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ApiError } from '@/lib/api';
import { env } from '@/lib/env';
import { useAuth } from '@/providers/AuthProvider';
import { authApi } from './authApi';
import { resolveNextRoute } from '@/routes/auth/resolveNextRoute';

interface Props {
  nextPath?: string | null;
}

export function GoogleSignInButton({ nextPath = null }: Props) {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  if (!env.googleClientId) {
    return (
      <p className="mt-4 text-xs text-(--color-fg-muted)" role="note">
        Login com Google indisponível (VITE_GOOGLE_CLIENT_ID não configurado).
      </p>
    );
  }

  const handleSuccess = async (cred: CredentialResponse) => {
    setError(null);
    const idToken = cred.credential;
    if (!idToken) {
      setError('Token Google ausente.');
      return;
    }
    try {
      const data = await authApi.loginWithGoogle(idToken);
      login(data.accessToken, data.user);
      navigate(resolveNextRoute(data.user, nextPath), { replace: true });
    } catch (err) {
      const msg =
        err instanceof ApiError && err.message
          ? err.message
          : 'Não foi possível concluir o login com Google.';
      setError(msg);
    }
  };

  return (
    <div className="mt-4 flex flex-col items-stretch gap-2">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => setError('Falha ao autenticar com o Google.')}
        useOneTap={false}
        text="continue_with"
      />
      {error ? (
        <p className="text-sm text-(--color-error)" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
